import React, { useCallback } from "react";
import { useField } from "formik";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { TransferRuleFormSchema } from "../constants";

export const ExcludeMatchedTransactionsCheckbox: React.FC = () => {
    const [field, , helpers] = useField<boolean>("excludeMatchedTransfers");
    const [{ value: matchingMode }] =
        useField<TransferRuleFormSchema["matchingMode"]>("matchingMode");

    const toggle = useCallback(() => {
        helpers.setValue(!field.value);
    }, [field.value, helpers]);

    // In "disallow" mode the preview is a list of currently-paired transfers
    // that will be unmatched. The "exclude matched" toggle has no meaning
    // there, so we hide it to avoid confusing the user.
    if (matchingMode === "disallow") {
        return null;
    }

    return (
        <Checkbox
            checked={field.value}
            onCheckedChange={toggle}
            label="Do not include transactions that currently have matches"
        />
    );
};
